<template>
    <div class="investment-box">
        <div class="banner-box">
            <img src="./../assets/img/investment/banner_investment.png" alt="">
        </div>
        <div class="investment-title">产品优势</div>
        <div class="investment-cpys">
            <div v-for="(item,index) in banner" :key="index">
                <img :src="item.src" alt="">
                <p>{{item.text}}</p>
            </div>
        </div>
        <!-- 服务与支持 -->
        <div class="investment-title">服务与支持</div>
        <ul class="investment-server">
            <li v-for="(item,index) in server" :key="index">
                <img :src="item.src" alt="">
                <span>{{item.text}}</span>
            </li>
        </ul>
         <div class="investment-title">招商条件</div>
         <ul class="investment-zs">
             <li v-for="(item,index) in zs" :key="index" :class="{active:index%2}">
                 <img :src="item.src" alt="">
                <p v-html="item.text"></p>
             </li>
         </ul>
    </div>
</template>
<script>
import img1 from "./../assets/img/investment/1.png";
import img2 from "./../assets/img/investment/2.png";
import img3 from "./../assets/img/investment/3.png";
import img4 from "./../assets/img/investment/4.png";
import img5 from "./../assets/img/investment/5.png";

import server1 from "./../assets/img/investment/server_1.png";
import server2 from "./../assets/img/investment/server_2.png";
import server3 from "./../assets/img/investment/server_3.png";
import server4 from "./../assets/img/investment/server_4.png";
import server5 from "./../assets/img/investment/server_5.png";
import server6 from "./../assets/img/investment/server_6.png";

import zs1 from "./../assets/img/investment/zs_1.png";
import zs2 from "./../assets/img/investment/zs_2.png";
import zs3 from "./../assets/img/investment/zs_3.png";
import zs4 from "./../assets/img/investment/zs_4.png";


export default {
  data() {
    return {
      banner: [
        {
          src: img1,
          text:
            "我们提供专业的消防维保系统，日常防火巡查系统，隐患排查与整改系统，物联网远程监控系统，AI智能摄像头系统。"
        },
        {
          src: img2,
          text:
            "我们服务全国10个省份，超过两万余家社会单位，300余家消防服务机构。"
        },
        {
          src: img3,
          text: "我们有互联网，物联网，人工智能及消防领域顶尖的技术团队。"
        },
        {
          src: img4,
          text: "  我们有巨大的市场空间，清晰的盈利模式。"
        },
        {
          src: img5,
          text: "我们有覆盖全国的售后服务网络，让服务更快捷。"
        }
      ],
      server: [
        {
          text: "提供智慧消防云服务平台整套解决方案",
          src: server1
        },
        {
          text: "提供大型项目招投标技术支持",
          src: server2
        },
        {
          text: "提供7×24小时项目运营技术保障及支持",
          src: server3
        },
        {
          text: "提供智慧消防运营培训、技术培训",
          src: server4
        },
        {
          text: "免费提供平台演示账号、宣传材料等",
          src: server5
        },
        {
          text: "协助代理商培养成熟的业务及技术人员",
          src: server6
        }
      ],
      zs:[
          {
              src:zs1,
              text:'在当地具有一定的行业客户渠道及<br>丰富的人脉关系'
          },
          {
              src:zs2,
              text:'有专门的销售人员销售小蜜蜂<br>智慧消防产品'
          },
          {
              src:zs3,
              text:'具备良好的企业形象、社会声誉<br>及行业声誉'
          },
          {
              src:zs4,
              text:'在当地工商行政管理局<br>注册的独立法人实体'
          },
      ]
    };
  }
};
</script>
<style lang="scss">
.investment-box {
    font-size: .24rem;
  .investment-title {
    @include lineheight(1.2rem);
    text-align: center;
    font-size: 0.28rem;
    font-weight: bold;
  }
  .investment-cpys {
    padding: 0 $padding;
    text-align: center;
    img {
      width: 1.2rem;
      margin: 0.5rem 0;
    }
    p {
      line-height: 2;
    }
  }
  .investment-server{
      background:#F8F8F7;
      padding:.5rem .65rem;
      li{
          background: #fff;
          @extend .radius;
          margin-top:.5rem;
          padding:.15rem .23rem;
          @extend .flex;
          align-items: center;
          position: relative;
          &:after{
              content:"";
              position: absolute;
              right:-.42rem;
              top:50%;
              transform: translateY(-50%);
              border:.21rem solid transparent;
              border-left-color: #fff;

          }

      }
      img{
          width:.73rem;
          margin-right:.32rem;
      }
  }
  .investment-zs{
      text-align: center;
      li{
          padding:.5rem 0;
          line-height: 2;
          &.active{
              background:#F8F8F7;
          }
          img{
              width:1.22rem;
              margin-bottom:.26rem;
          }
      }
  }
}
</style>
